import { RExpertGuideBrowse } from "@/modules/Guide/browse/RGuideBrowse";
import { RGuideTemplate } from "@/modules/Guide/template/RGuideTemplate";
import { RouteConfig } from "vue-router";

export const RExpertGuide: RouteConfig = {
  path: "guide",
  component: () =>
    import(
      /* webpackChunkName: "expert-guide" */
      "./VExpertGuide.vue"
    ),
  meta: {
    title: "Guide",
    icon: "book-outline",
    newIcon: "book",
  },
  children: [RExpertGuideBrowse, RGuideTemplate],
};
